<template>
  <footer>
    <div class="ys_footer ys">
      <div class="ys_content top">
        <div class="ys_footer_left">
          <img class="ys_footer_left_log" :src="sysInfo.choice_bottom_logo|setImage" v-if="sysInfo.choice_bottom_logo">
          <img class="ys_footer_left_log" src="@/static/logo-02.png" @click="select('index')" v-else>
          <div class="ys_footer_left_name">提供全场景技术解决方案及全品类电商货源</div>
          <div class="ys_footer_left_tel">
            <i class="icon-a-24gf-phoneBubble"></i> 18973183401
          </div>
        </div>
        <ul class="link">
          <li>微唯宝</li>
          <li class="ys_footer_li" @click="navTo('https://www.yuncentry.com','',true)">首页</li>
          <li class="ys_footer_li" @click="navTo('https://www.wiwibao.com/index/index/about','',true)">关于微唯宝</li>
          <li class="ys_footer_li" @click="navTo('https://www.wiwibao.com/index/index/news','',true)">新闻中心</li>
          <li class="ys_footer_li" @click="navTo('https://www.wiwibao.com/index/index/contact','',true)">联系我们</li>
        </ul>
        <ul>
          <li>行业解决方案</li>
          <li class="ys_footer_li" @click="navTo('https://wiwipu.com','',true)">蔬果云Saas系统</li>
          <li class="ys_footer_li" @click="navTo('https://www.douhuomall.com','',true)">微唯宝供应链</li>
          <li class="ys_footer_li" @click="navTo('https://www.yuncentry.com/index/yshop/mall.html','',true)">微唯宝商城系统</li>
        </ul>
      </div>
    </div>
    <div class="ipc">
      <small>Powered by 微唯宝 ©2011-2023 湘ICP备15019552号-1 湘公网安备 43060202000167号</small>
    </div>
  </footer>
</template>
<script>
import {mapState} from 'vuex'
export default {
  data(){
    return {

    }
  },
  computed:{
    ...mapState(['sysInfo'])
  },
}
</script>

<style scoped lang="scss">
  footer {
    .ys_footer {
      background-color: #2C2D32;
      color: #fff;
      padding: 80px 0;

      .top {
        display: flex;
        justify-content: space-evenly;
      }

      &_left {
        width: 55%;

        &_log {
          width: 200px;
          margin-top: 18px;
        }

        &_name {
          color: #BEB1B3;
          font-size: 18px;
          margin: 15px 0 40px;
        }

        &_tel {
          font-size: 30px;
          color: #BEB1B3;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .icon-a-24gf-phoneBubble {
            font-size: 34px;
            color: #BEB1B3;
            margin-right: 10px;
          }
        }
      }

      ul {
        li {
          list-style: none;
          color: #BEB1B3;
          padding-bottom: 15px;
          position: relative;
        }
        li.ys_footer_li{
          cursor: pointer;
        }

        li:first-child {
          font-size: 18px;
          color: #fff;
          margin-bottom: 35px;
          background: linear-gradient(180deg, #604D4E, #2C2D32);
          background-size: 90px 18px;
          background-repeat: no-repeat;
          background-position-y: 12px;
        }

        li.ys_footer_li:hover {
          color: var(--theme-color);
        }
      }
    }

    .ipc {
      line-height: 3rem;
      text-align: center;
      width: 100%;
      background-color: #26272B;
      color: #fff;

      small {}
    }
  }
</style>
